
export default {

    setList(state, list) {
        state.list = list;
    },
    setRequest(state, request) {
        state.request = request;
    },
}